import { appConstants } from "../helpers/app-constants";

let head = {
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
};

export const getApiDetails = {
  getVehicleLoadStatistics: {
    route: `/logistics/getVehicleLoadStatistics/`,
    loding: appConstants.LOADING_LP_VEHICLE_LOAD_STATISTICS,
    success: appConstants.GET_LP_VEHICLE_LOAD_STATISTICS,
    error: appConstants.ERRORS_LP_VEHICLE_LOAD_STATISTICS,
    headers: head,
  },
  getCurrentVehicleLoad: {
    route: `/logistics/getCurrentVehicleLoad`,
    loding: appConstants.LOADING_CURRENT_VEHICLE_LOAD,
    success: appConstants.GET_CURRENT_VEHICLE_LOAD,
    error: appConstants.ERRORS_CURRENT_VEHICLE_LOAD,
    headers: head,
  },
  getGuestJWTToken: {
    route: `/api/getGuestToken`,
    loding: appConstants.LOADING_GUEST_JWT_TOKEN,
    success: appConstants.GET_GUEST_JWT_TOKEN,
    error: appConstants.ERRORS_GUEST_JWT_TOKEN,
    headers: head,
  },
  renewGuestJWTToken: {
    route: `/api/renewGuestToken`,
    loding: appConstants.LOADING_GUEST_JWT_TOKEN,
    success: appConstants.GET_GUEST_JWT_TOKEN,
    error: appConstants.ERRORS_GUEST_JWT_TOKEN,
    headers: head,
  },
  getUnreadNotifications: {
    route: `/notifications/getUnread`,
    loding: appConstants.LOADING_UNREAD_NOTIFICATIONS,
    success: appConstants.GET_UNREAD_NOTIFICATIONS,
    error: appConstants.ERRORS_UNREAD_NOTIFICATIONS,
    headers: head,
  },
  getRoles: {
    route: `/roles`,
    loding: appConstants.LOADING_ROLES,
    success: appConstants.GET_ROLES,
    error: appConstants.ERRORS_ROLES,
    headers: head,
  },
  getRolesTypes: {
    route: `/roletypes`,
    loding: appConstants.LOADING_ROLES_TYPES,
    success: appConstants.GET_ROLES_TYPES,
    error: appConstants.ERRORS_ROLES_TYPES,
    headers: head,
  },
  getSellerTypes: {
    route: `/sellertypes`,
    loding: appConstants.LOADING_SELLER_TYPES,
    success: appConstants.GET_SELLER_TYPES,
    error: appConstants.ERRORS_SELLER_TYPES,
    headers: head,
  },
  getSubscriptionPlans: {
    route: `/subscriptionPlans`,
    loding: appConstants.LOADING_SUBSCRIPTION_PLANS,
    success: appConstants.GET_SUBSCRIPTION_PLANS,
    error: appConstants.ERRORS_SUBSCRIPTION_PLANS,
    headers: head,
  },
  getBhreeAdminBasicTables: {
    route: `/admin/getTableData`,
    loding: appConstants.LOADING_BHAREE_ADMIN_BASIC_TABLE,
    success: appConstants.GET_BHAREE_ADMIN_BASIC_TABLE,
    error: appConstants.ERRORS_BHAREE_ADMIN_BASIC_TABLE,
    headers: head,
  },
  getBrands: {
    route: `/brands`,
    loding: appConstants.LOADING_BRANDS,
    success: appConstants.GET_BRANDS,
    error: appConstants.ERRORS_BRANDS,
    headers: head,
  },
  getVehicleTypes: {
    route: `/api/getVehicleTypes`,
    loding: appConstants.LOADING_VEHICLE_TYPES,
    success: appConstants.GET_VEHICLE_TYPES,
    error: appConstants.ERRORS_VEHICLE_TYPES,
    headers: head,
  },
  getBuyerBrands: {
    route: `/api/getBrands`,
    loding: appConstants.LOADING_BRANDS,
    success: appConstants.GET_BRANDS,
    error: appConstants.ERRORS_BRANDS,
    headers: head,
  },
  getDealOfTheDay: {
    route: `/api/dealsoftheday`,
    loding: appConstants.LOADING_DEALS_OF_THE_DAY,
    success: appConstants.GET_DEALS_OF_THE_DAY,
    error: appConstants.ERRORS_DEALS_OF_THE_DAY,
    headers: head,
  },
  getProducts: {
    route: `/products`,
    loding: appConstants.LOADING_PRODUCTS,
    success: appConstants.GET_PRODUCTS,
    error: appConstants.ERRORS_PRODUCTS,
    headers: head,
  },
  getUserList: {
    route: `/admin/getUsersList`,
    loding: appConstants.LOADING_USER_LIST,
    success: appConstants.GET_USER_LIST,
    error: appConstants.ERRORS_USER_LIST,
    headers: head,
  },
  getUserListSeller: {
    route: `/admin/getUsersList?roleType=seller`,
    loding: appConstants.LOADING_USER_LIST,
    success: appConstants.GET_USER_LIST,
    error: appConstants.ERRORS_USER_LIST,
    headers: head,
  },
  getUserListBuyer: {
    route: `/admin/getUsersList?roleType=buyer`,
    loding: appConstants.LOADING_USER_LIST,
    success: appConstants.GET_USER_LIST,
    error: appConstants.ERRORS_USER_LIST,
    headers: head,
  },
  getUserListEmployee: {
    route: `/admin/getUsersList?roleType=bharee`,
    loding: appConstants.LOADING_USER_LIST,
    success: appConstants.GET_USER_LIST,
    error: appConstants.ERRORS_USER_LIST,
    headers: head,
  },
  getUserListLogisticPartner: {
    route: `/admin/getUsersList?roleType=logistic_partner`,
    loding: appConstants.LOADING_USER_LIST,
    success: appConstants.GET_USER_LIST,
    error: appConstants.ERRORS_USER_LIST,
    headers: head,
  },
  getFilters: {
    route: `/api/getFilters`,
    loding: appConstants.LOADING_FILTERS,
    success: appConstants.GET_FILTERS,
    error: appConstants.ERRORS_FILTERS,
    headers: head,
  },
  getServiceTaxDetails: {
    route: `/api/getServiceTaxDetails`,
    loding: appConstants.LOADING_SERVICET_TAX_DETAILS,
    success: appConstants.GET_SERVICET_TAX_DETAILS,
    error: appConstants.ERRORS_SERVICET_TAX_DETAILS,
    headers: head,
  },
  getAddressess: {
    route: `/users/getAddressByUserId`,
    loding: appConstants.LOADING_ADDRESSES,
    success: appConstants.GET_ADDRESSES,
    error: appConstants.ERRORS_ADDRESSES,
    headers: head,
  },
  getFactoryInfo: {
    route: `/users/getFactoryInfo`,
    loding: appConstants.LOADING_FACTORY_INFO,
    success: appConstants.GET_FACTORY_INFO,
    error: appConstants.ERRORS_FACTORY_INFO,
    headers: head,
  },
  getLiveOffer: {
    route: `/liveoffers`,
    loding: appConstants.LOADING_LIVE_OFFERS,
    success: appConstants.GET_LIVE_OFFERS,
    error: appConstants.ERRORS_LIVE_OFFERS,
    headers: head,
  },
  getBankInfo: {
    route: `/users/getBankInfo`,
    loding: appConstants.LOADING_BANK_INFO,
    success: appConstants.GET_BANK_INFO,
    error: appConstants.ERRORS_BANK_INFO,
    headers: head,
  },
  getLastMonthPendingPayouts: {
    route: `/admin/getLastMonthPendingPayouts`,
    loding: appConstants.LOADING_PENDING_PAYOUTS_COUNT,
    success: appConstants.GET_PENDING_PAYOUTS_COUNT,
    error: appConstants.ERRORS_PENDING_PAYOUTS_COUNT,
  },
  getAdminStats: {
    route: `/admin/getDashboardData`,
    loding: appConstants.LOADING_ADMIN_STATS,
    success: appConstants.GET_ADMIN_STATS,
    error: appConstants.ERRORS_ADMIN_STATS,
    headers: head,
  },
  getCompanyInfo: {
    route: `/users/companyInfo`,
    loding: appConstants.LOADING_COMPANY_INFO,
    success: appConstants.GET_COMPANY_INFO,
    error: appConstants.ERRORS_COMPANY_INFO,
    headers: head,
  },
  getCart: {
    route: `/cart`,
    loding: appConstants.LOADING_CART,
    success: appConstants.GET_CART,
    error: appConstants.ERRORS_CART,
    headers: head,
  },
  getLiveOfferProductsList: {
    route: `/liveoffers/productlist`,
    loding: appConstants.LOADING_LIVEOFFER_PRODUCTS_LIST,
    success: appConstants.GET_LIVEOFFER_PRODUCTS_LIST,
    error: appConstants.ERRORS_LIVEOFFER_PRODUCTS_LIST,
    headers: head,
  },
  getOrders: {
    route: `/orders`,
    loding: appConstants.LOADING_ORDERS,
    success: appConstants.GET_ORDERS,
    error: appConstants.ERRORS_ORDERS,
    headers: head,
  },
  getOrder: {
    route: `/orders`,
    loding: appConstants.LOADING_CURRENT_ORDER,
    success: appConstants.GET_CURRENT_ORDER,
    error: appConstants.ERRORS_CURRENT_ORDER,
    headers: head,
  },
  getProductById: {
    route: `/products`,
    loding: appConstants.LOADING_CURRENT_PRODUCT,
    success: appConstants.GET_CURRENT_PRODUCT,
    error: appConstants.ERRORS_CURRENT_PRODUCT,
    headers: head,
  },
  getProductDetails: {
    route: `/api/productdetails`,
    loding: appConstants.LOADING_CURRENT_PRODUCT,
    success: appConstants.GET_CURRENT_PRODUCT,
    error: appConstants.ERRORS_CURRENT_PRODUCT,
    headers: head,
  },
  getEnquiry: {
    route: `/enquiry`,
    loding: appConstants.LOADING_ENQUIRY,
    success: appConstants.GET_ENQUIRY,
    error: appConstants.ERRORS_ENQUIRY,
    headers: head,
  },
  getSellerAddress: {
    route: `/users/getSellerAddress`,
    loding: appConstants.LOADING_SELLER_ADDRESS,
    success: appConstants.GET_SELLER_ADDRESS,
    error: appConstants.ERRORS_SELLER_ADDRESS,
    headers: head,
  },
  getBuyerAddress: {
    route: `/users/getBuyerAddress`,
    loding: appConstants.LOADING_BUYER_ADDRESS,
    success: appConstants.GET_BUYER_ADDRESS,
    error: appConstants.ERRORS_BUYER_ADDRESS,
    headers: head,
  },
  getAppConfig: {
    route: `/appconfig`,
    loding: appConstants.LOADING_MAX_MOQ_FULFILLMENT,
    success: appConstants.GET_MAX_MOQ_FULFILLMENT,
    error: appConstants.ERRORS_MAX_MOQ_FULFILLMENT,
    headers: head,
  },
  getGstStates: {
    route: `/gstStates`,
    loding: appConstants.LOADING_GST_STATES,
    success: appConstants.GET_GST_STATES,
    error: appConstants.ERRORS_GST_STATES,
    headers: head,
  },
  checkEmailVerified: {
    route: `/api/checkEmailVerified`,
    loding: appConstants.LOADING_EMAIL_VERIFIED,
    success: appConstants.EMAIL_VERIFIED,
    error: appConstants.ERRORS_EMAIL_VERIFIED,
    headers: head,
  },
  sendEmailVerificationLink: {
    route: `/api/sendEmailVerificationLink`,
    loding: appConstants.LOADING_SEND_EMAIL_VERIFICATION_LINK,
    success: appConstants.SEND_EMAIL_VERIFICATION_LINK,
    error: appConstants.ERRORS_SEND_EMAIL_VERIFICATION_LINK,
    headers: head,
  },
};
